import React from "react";

export default function HealthCheck() {
    return '';
}